import EmailTemplateSelect from './EmailTemplateSelect';

export default EmailTemplateSelect;
